export default class OrganizationApp {
  constructor(API) {
    this.api = API;
  }
  /* CRUD */
  async createOrganizationApp(
    optionalMetadata,
    isAffiliate,
    orgID,
    hashedWorksafeID,
    additionalManagerID,
    notes
  ) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/organization/${orgID}/app`;
    req.body = {
      ...(optionalMetadata ? { metadata: optionalMetadata } : {}),
      isAffiliate,
      notes,
      hashedWorksafeID,
      additionalManagerID: additionalManagerID ? additionalManagerID : "",
    };
    return await req.exec();
  }
  async updateOrganizationApp(orgID, content) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = "/organization/" + (orgID ? orgID + "/" : "") + "app";
    req.body = { ...content };
    return await req.exec();
  }
  async updateOrganizationAppSettings(orgID, content) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = "/organization/" + (orgID ? orgID + "/" : "") + "app/settings";
    req.body = { ...content };
    return await req.exec();
  }
  async deleteOrganizationApp(orgID, isSoft) {
    const req = await this.api.newBaseRequest("DELETE");
    req.path = "/organization/" + orgID + (isSoft ? "/app/soft" : "/app");
    return await req.exec();
  }
  async getOrganizationApp(orgID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/organization/" + (orgID ? orgID + "/" : "") + "app";
    return await req.exec();
  }
  async getOrganizationAppsByOrgID(orgID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/organization/" + orgID + "/apps/all";
    return await req.exec();
  }
  /* Affiliate helper */
  async getOrganizationAppByAffiliateID(affiliateID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/organization/" + affiliateID + "/app/affiliate";
    return await req.exec();
  }
  /* Member OApps helper */
  async getOrganizationAppsByMember(userID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/organization/app/user/orgs/" + userID;
    return await req.exec();
  }
  /* Search Operations */
  async searchOrganizationsAppsByTerm(searchTerm, filters) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/organizations/apps/search";
    req.body = { searchTerm, filter: filters };
    return await req.exec();
  }
  async searchAllOrganizationsApps(filters) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/organizations/apps/search/all";
    req.body = { filter: filters };
    return await req.exec();
  }
  async searchOrganizationAppsAutocomplete(value) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/organizations/apps/search/autocomplete";
    req.body = { value };
    return await req.exec();
  }
  async describeOrganizationAppsByOrgID(orgID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/organization/" + (orgID ? orgID + "/" : "") + "apps";
    return await req.exec();
  }
  async exportOrganizationManagersByOrgID(orgID) {
    const req = await this.api.newBaseRequest("GET");
    req.path =
      "/organization/" + (orgID ? orgID + "/" : "") + "apps/exportManagers";
    req.bodyType = "JSON/BLOB";
    return await req.exec();
  }

  /* Soon to be deprecated */
  // TODO: review this utilization, API is badly doing this
  async getOrganizationAppsByIDs(IDs) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/organizations/get/apps";
    req.body = { orgIDs: IDs };
    return await req.exec();
  }
}
